import { hasS3Object } from "@/lib/aws-amplify/storage";

import { Converter } from "@/components/features/_shared";
import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import { normalizeOverSiteControllerPeopleNum } from "../../../../_shared/normalize-over-site-controller-people-num";


import type { ProductRoomFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductRoomFormModel["InputModel"] => {
	const { roomNewItem, hotelPolicy } = serverModel;

	// 他のアイテムが初期値になりうるプロパティ
	const requiredPrepMillisecond = roomNewItem.requiredPrepMillisecond || hotelPolicy?.requiredPrepMillisecond || 0;
	const amenities = roomNewItem.amenities ?? hotelPolicy?.amenities ?? [];

	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const inputModel: ProductRoomFormModel["InputModel"] = {
		address: roomNewItem.address,
		availablePlanIDs: roomNewItem.availablePlanIDs,
		beds: roomNewItem.beds,
		capacityAdultMaximum: roomNewItem.capacityAdultMaximum,
		capacityKidsMaximum: roomNewItem.capacityKidsMaximum,
		capacityPeopleMaximum: roomNewItem.capacityPeopleMaximum,
		catchCopy: roomNewItem.catchCopy,
		description: roomNewItem.description,
		geoLocation: roomNewItem.geoLocation,
		hotelID: roomNewItem.hotelID,
		inSale: roomNewItem.inSale,
		isDormitoryType: roomNewItem.isDormitoryType,
		isShowStockPreview: roomNewItem.isShowStockPreview ?? false,
		isExtendSiteControllerPeopleNum: roomNewItem.isExtendSiteControllerPeopleNum,
		isKidsUnavailable: roomNewItem.isKidsUnavailable,
		isNotDiscountTarget: roomNewItem.isNotDiscountTarget ?? false,
		keyVisuals: roomNewItem.keyVisuals ?? [],
		kidsPolicy: roomNewItem.kidsPolicy?.map(Converter.kidsPolicyItemConverter) ?? undefined,
		mainKeyVisual: hasS3Object(roomNewItem.mainKeyVisual) ? roomNewItem.mainKeyVisual : DUMMY_IMAGE.s3Object,
		maxRoomNum: roomNewItem.maxRoomNum,
		name: roomNewItem.name,
		// 複製元に料金項目が空の固定料金グループが残っている場合に、既存部屋の編集と同様に空欄の料金項目を補完する
		overSiteControllerPeopleNum: normalizeOverSiteControllerPeopleNum(roomNewItem),
		roomID: roomNewItem.roomID,
		roomSize: roomNewItem.roomSize,
		saleTypeForPlan: roomNewItem.saleTypeForPlan,

		// 他のアイテムが初期値になりうるプロパティ
		amenities,
		requiredPrepMillisecond,

		// InputModel 固有のプロパティ
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
	} satisfies ProductRoomFormModel["InputModel"];

	return inputModel;
};
